export const GET_VENDITA_TABLE = "GET_VENDITA_TABLE";
export const GET_NOLEGGIO_TABLE = "GET_NOLEGGIO_TABLE";
export const GET_RESTITUZIONI_TABLE = "GET_RESTITUZIONI_TABLE";
export const GET_NOLEGGIO_IN_SCADENZA_TABLE = "GET_NOLEGGIO_IN_SCADENZA_TABLE";
export const GET_DEVICE_DETAILS = "GET_DEVICE_DETAILS";
export const SET_WRENCH_LOADING_DEVICES_V2 = "SET_WRENCH_LOADING_DEVICES_V2";
export const SET_WRENCH_DETAILS_DEVICE_V2 = "SET_WRENCH_DETAILS_DEVICE_V2";
export const SET_DEVICE_TAB_COUNT = "SET_DEVICE_TAB_COUNT";
export const SET_DEVICE_TAB_COUNT_LOADING = "SET_DEVICE_TAB_COUNT_LOADING";
export const GET_RESTITUZIONI_DETAILS_AND_LOADING = "GET_RESTITUZIONI_DETAILS_AND_LOADING";
export const GET_RESTITUZIONI_DETAILS_TABLE = "GET_RESTITUZIONI_DETAILS_TABLE";
export const SET_DEVICE_V2_CSV_DOWNLOAD_LOADING = "SET_DEVICE_V2_CSV_DOWNLOAD_LOADING"
